import * as constants from '../constants/common.constants';

interface CommonState {
  isLoginPopupOpen: boolean;
  isLocationPopupOpen: boolean;
  isSearchPopupOpen: boolean;
  isArtistPopupOpen?: boolean;
  selectedTicket: string | null;
}

const initialState: CommonState = {
  isLoginPopupOpen: false,
  isLocationPopupOpen: false,
  isSearchPopupOpen: false,
  isArtistPopupOpen: false,
  selectedTicket: null,
};

export const commonReducer = (
  state = initialState,
  action: any,
): CommonState => {
  switch (action.type) {
    case constants.LOGIN_POPUP:
      return {
        ...state,
        isLoginPopupOpen: action.payload,
      };
    case constants.LOCATION_POPUP:
      return {
        ...state,
        isLocationPopupOpen: action.payload,
      };
    case constants.SEARCH_POPUP:
      return {
        ...state,
        isSearchPopupOpen: action.payload,
      };
    case constants.ARTIST_POPUP:
      return {
        ...state,
        isArtistPopupOpen: action.payload,
      };
    case constants.TICKET_POPUP:
      return {
        ...state,
        selectedTicket: action.payload,
      };
    default:
      return state;
  }
};
